import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../../redux/configureStore';
import { setIdTranscao } from '../../../../../../../../../redux/fetchActions/legadoPage/transferApp';
import Wrapper from '../../../../../../../../../shared/components/Wrapper';

function SetIDTransaction() {
  const transfersFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );
  const dispatch = useDispatch();
  function setID(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setIdTranscao(value));
  }

  return (
    <Wrapper.Default
      width="35%"
      style={{ padding: '0 15px 5px' }}
      isActive
      flexDirection="row"
      alignItens="start">
      <span
        style={{
          fontWeight: 700,
          lineHeight: '34px',
          minWidth: '140px',
        }}>
        ID da transação:
      </span>
      <Form.Control
        type="text"
        value={transfersFilterState.idTransaction}
        onChange={(event) => setID(event)}
      />
    </Wrapper.Default>
  );
}

export default SetIDTransaction;
